// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import { get } from "lodash-es";

import { trans } from "src/translations";
import { pipeValidators, hasOneElementWhen } from "utils/validation";

import { AndroidProfilesForm } from "../../../components/Profiles/AndroidProfilesForm";
import { APP_PROFILES_SECTION_APP_TYPES } from "../../../constants";

export default {
  name: trans.APP_EDIT__ANDROID_PROFILES_SECTION_NAME(),
  isEnabled: (props) =>
    APP_PROFILES_SECTION_APP_TYPES.includes(props.appData.type),
  components: [
    {
      component: AndroidProfilesForm,
      fields: [
        "metadata.android_profiles[].name",
        "metadata.android_profiles[].action",
        "metadata.android_profiles[].package",
        "metadata.android_profiles[].class",
        "metadata.android_profiles_error", // special field only for displaying errors for group of fields
      ],
      validate: pipeValidators(
        hasOneElementWhen("metadata.android_profiles_error", (values) => {
          return (
            values.metadata.android_profiles.length === 0 &&
            values.metadata.linux_profiles.length === 0
          );
        })
      ),
      initialValues: {
        metadata: {
          android_profiles: [],
        },
      },
      props: ({ formikProps }) => ({
        profilesFieldName: "metadata.android_profiles",
        generalError: get(
          formikProps,
          "errors.metadata.android_profiles_error"
        ),
        ...formikProps,
      }),
    },
  ],
};
